import { GroupedSortOption } from "@/types/search.types";

export type TFunction = (key: string, values?: Record<string, any>) => string;

/**
 * Get grouped sort options for developers/realtors page with proper translations
 */
export const getGroupedSortOptions = (t: TFunction): GroupedSortOption[] => [
  {
    groupLabel: t("By price"),
    options: [
      { value: "price_desc", label: t("Price: high to low") },
      { value: "price_asc", label: t("Price: low to high") },
    ],
  },
  {
    groupLabel: t("By date added"),
    options: [
      { value: "date_desc", label: t("From new to old") },
      { value: "date_asc", label: t("From old to new") },
    ],
  },
  {
    groupLabel: t("By date updated"),
    options: [
      { value: "updated_desc", label: t("From recent to old") },
      { value: "updated_asc", label: t("From old to recent") },
    ],
  },
  {
    groupLabel: t("By call date"),
    options: [
      { value: "call_date_desc", label: t("From recent to old") },
      { value: "call_date_asc", label: t("From old to recent") },
    ],
  },
  {
    groupLabel: t("By call status"),
    options: [
      { value: "call_status_desc", label: t("From recent to old") },
      { value: "call_status_asc", label: t("From old to recent") },
    ],
  },
];
